export var getServerJSON = function getServerJSON(scriptId) {
  var serverRenderedScript = document.getElementById(scriptId);
  /**
   * Either ScriptTag isn't rendered into DOM
   * or React is running in CSR-mode
   */
  if (!serverRenderedScript) return null;
  return JSON.parse(serverRenderedScript.innerText);
};